import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@env/environment';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { routesConstants } from '@app/shared/models/LinksView';

/**
 * Prefixes all requests with `environment.serverUrl`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {

	constructor(private authenticationService: AuthenticationService, private router: Router) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// solo se solicita a maestronet cuando se va a hacer el login en la aplicacion
		if (request.url.startsWith('/maestronet')) {
		console.log('Login en maestronet: ' + request.urlWithParams);
		return next.handle(request);
		}

		request = request.clone({
			url: environment.serverUrl + request.url
		});
		//obtenemos el token del almacenamiento de sesion
		if (this.authenticationService.isAuthenticated()) {
   			const token = this.authenticationService.credentials.token;
			request = request.clone({
				setHeaders: { Authorization: `Bearer ${token}` }
			});
		}

		if (!request.headers.has('Content-Type')) {
			request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
		}
		else if (request.headers.get('Content-Type') === ''){
			request = request.clone({ headers: request.headers.delete('Content-Type') });
		}

		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status === 401) {
					console.log('Error 401 detectado en api-prefix interceptor - Redirigiendo a landing');
					this.authenticationService.clearCredentials();
					this.router.navigate([routesConstants.landing], { replaceUrl: true });
				}
				return throwError(() => error);
			})
		);
	}
}
